module.exports = __webpack_public_path__ + "static/media/asset1.a8f59970.png";